export enum HelpWithType {
  Application,
  First,
  FirstInCons,
  Second,
  Third,
  Fourth,
}

export enum WebSectionId {
  R11554 = 'R11554',
  R11852 = 'R11852',
}

export enum HFWSScriptSrc {
  GLCPLogoBasicFooter = '',
  HPELogoBasicFooter = '&header_logo=hpe',
  HPELogoDetailedFooter = '&header_logo=hpe&console_mode=false',
}

export enum FormUrlParam {
  BlankRequest = 'glcp_other',
  ComputeSupport = 'computesupport',
  Denali = 'denali',
  DeveloperPortal = 'developerportal',
  DSSupport = 'dssupport',
  GLCentral = 'glcentral',
  GLSupport = 'glsupport',
  GlobalTrade = 'supportrequest',
  GlobalTrade_old = 'globaltrade',
  GlobalTrade_SupportCenter = 'supportrequest_supportcenter',
  GlobalTrade_SupportCenter_old = 'globaltrade_supportcenter',
  GreenLakeSupport = 'greenlakesupport',
  GreenLakeSupportTest = 'greenlakesupport_test',
  LoginSupport = 'loginsupport',
  LoginSupport_GLCP = 'loginsupport_glcp',
  LoginSupport_ML = 'loginsupportml',
  Marketplace = 'greenlake_marketplace',
  OpsRamp = 'opsramp',
  ManagedCloudService = 'mcs',
  NetworkingArubaCentral = 'nac',
  DashboardsAndMonitoring = 'dam',
  SupportHub = 'supporthub',
  OSQBM = 'osqbm',
  PrivateCloud = 'privatecloud',
  RPL_SupportCenter = 'block_supportcenter',
  RPL_SupportCenter_old = 'rpl_supportcenter',
  RPL_SupportCenter_GLCP = 'loginblock_glcp',
  RPL_SupportCenter_GLCP_old = 'rpl_supportcenter_glcp',
  SWD_SupportCenter = 'swd_supportcenter',
  SWD_SupportCenter_GLCP = 'swd_supportcenter_glcp',
}

export enum Languages {
  EN = 'English',
  JA = 'Japanese',
  ES = 'Spanish',
  DE = 'German',
  FR = 'French',
  IT = 'Italian',
  PT_BR = 'Brazilian Portuguese',
  KO = 'Korean',
  TR = 'Turkish',
  ZH_CN = 'Chinese (Simplified)',
  ZH_TW = 'Chinese (Traditional)',
  ID = 'Indonesian',
}

export enum ChinaRegions {
  HK = 'Hong Kong SAR',
  TW = 'Taiwan',
}
